/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
*/
export const environment = {
  production: true,
  projectName: 'Pbase',
  apiUrl: 'https://ruteo.tecsolutions.com.ar:8070/api/v1/',
  serverSocket: 'https://ruteo.tecsolutions.com.ar:8450',
  xdebug: false,
  strSecure: 'Pbase',
  version: 1,
  versionFile: 'version.json',
  timeCheckVersion: 60000,
  baseUrl: '/',
  entorno: 'prod'  
};
